import React from "react"

import styles from "./Image.module.scss"

const Image = ({
  image,
  aspectRatio,
  widths = [],
  fill,
  alt,
  ariaHidden,
  dominantColorEnabled,
  preload,
  disableCloudinary,
}) => {
  const cloudinaryAspectRatio = aspectRatio
    ? ",ar_" + aspectRatio + ",c_fill/"
    : ""
  const sourceUrl = image?.sourceUrl

  const sourcePath = image?.cloudinaryDetails?.public_id
    ? `${image.cloudinaryDetails.public_id}/${image.cloudinaryDetails.original_filename}.${image.cloudinaryDetails.format}`
    : null

  const aspectRatioArray = aspectRatio?.split(":")

  const fixedAspectRatio =
    aspectRatioArray?.length === 2
      ? Math.round((aspectRatioArray[1] / aspectRatioArray[0]) * 100 * 10) /
          10 +
        "%"
      : false

  const transparent =
    image?.hasTransparency || image?.sourceUrl?.includes(".png")
  const dominantColor =
    image?.dominantColor && dominantColorEnabled ? image.dominantColor : null
  const width = image?.mediaDetails?.width
  const height = image?.mediaDetails?.height

  const paddingBottom = aspectRatio
    ? fixedAspectRatio
    : image?.mediaDetails
    ? Math.round(
        (image.mediaDetails.height / image.mediaDetails.width) * 100 * 10
      ) /
        10 +
      "%"
    : "56.25%"

  const cloudinaryUrl =
    process.env.GATSBY_IMAGE_PROXY_URL &&
    !disableCloudinary &&
    cloudinaryAspectRatio &&
    sourcePath
      ? process.env.GATSBY_IMAGE_PROXY_URL +
        "/f_auto,q_auto" +
        cloudinaryAspectRatio +
        "/" +
        sourcePath
      : sourceUrl

  const srcSetStringArray = widths.map((size) => {
    return `${process.env.GATSBY_IMAGE_PROXY_URL}/w_${size},f_auto,q_auto${cloudinaryAspectRatio}/${sourcePath} ${size}w`
  })

  const srcSetString =
    process.env.GATSBY_IMAGE_PROXY_URL &&
    image?.mediaDetails &&
    !disableCloudinary &&
    //cloudinaryAspectRatio &&
    sourcePath
      ? srcSetStringArray.join(", ")
      : null

  /* */

  //const showImage = disableCloudinary || image?.cloudinaryDetails?.public_id
  const showImage = sourceUrl

  return (
    <div
      className={`${styles.responsiveimagecontainer} ${
        transparent ? styles.transparent : null
      } ${fill ? styles.responsiveimagecontainerfill : null}`}
      style={{
        paddingBottom: !fill && paddingBottom ? paddingBottom : "inherit",
        backgroundColor: dominantColor && !transparent ? dominantColor : null,
      }}
    >
      {showImage && (
        <>
          <img
            className={`lazyload ${preload ? "lazypreload" : ""} ${
              styles.responsiveimage
            }`}
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEAAAAALAAAAAABAAEAAAI="
            data-src={cloudinaryUrl}
            data-srcset={srcSetString}
            data-sizes={preload ? "100vw" : "auto"}
            width={width}
            height={height}
            alt={
              alt
                ? alt
                : image?.altText
                ? image.altText
                : image?.altTextOriginal
                ? image.altTextOriginal
                : ""
            }
            aria-hidden={ariaHidden}
            loading={preload ? "eager" : "auto"}
          />
          <noscript>
            <img
              className={styles.responsiveimage}
              src={cloudinaryUrl}
              srcset={srcSetString}
              width={width}
              height={height}
              alt={
                alt
                  ? alt
                  : image?.altText
                  ? image.altText
                  : image?.altTextOriginal
                  ? image.altTextOriginal
                  : ""
              }
              aria-hidden={ariaHidden}
              loading={preload ? "eager" : "auto"}
            />
          </noscript>
        </>
      )}
    </div>
  )
}

export default Image

Image.defaultProps = {
  dominantColorEnabled: true,
}
